// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/widgets/metadataWidget.styl
// module id = 393
// module chunks = 0